import { get } from 'helpers/util'
import * as actions from 'redux/actions/notification.actions'

const initialState = {
  notifications: []
}

const notificationReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getNotificationOverviewSuccess.type: {
      const data = []
      if (payload.data?.length) {
        payload.data.forEach(itemList => {
          const date = get([itemList, 'attributes', 'date'], '')
          const list = get([itemList, 'attributes', 'results', 'data'], [])
          list.forEach(item => {
            data.push({
              date,
              ...item?.attributes
            })
          })
        })
      }
      return { ...state, notifications: data }
    }
    default:
      return state
  }
}
export default notificationReducer
